import React,{Component} from 'react';

import {Row,Col,Button} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';


class PlainSendForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            body: '',
            segments: null,
            icon: '',
            image: '',
            badge: '',
            url: '',
            sound: '',
            vibration: '',
            btn1Title: '',
            btn1Icon: '',
            btn1Url: '',
            btn2Title: '',
            btn2Icon: '',
            btn2Url: ''
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleFieldChange(event) {
        const {target} = event;
        const {value,name} = target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        let form = this.state;

        form = Object.keys(form).reduce((obj, param) => {
            let value = form[param];
            if(value) {
                obj[param] = value;
            }

            return obj;
        },{});

        this.props.onSubmit(form);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <FieldGroup
                    name="title"
                    label="Title:"
                    onChange={this.handleFieldChange}
                    value={this.state.title}
                    required
                />
                <FieldGroup
                    componentClass="textarea"
                    name="body"
                    label="Body:"
                    onChange={this.handleFieldChange}
                    value={this.state.body}
                    required
                />
                <SelectWrap
                    values={this.props.segments}
                    label="Segments:"
                    name="segments"
                    onChange={this.handleFieldChange}
                    value={this.state.segments}
                    multi={true}
                />

                <FieldGroup
                    name="icon"
                    label="Icon:"
                    onChange={this.handleFieldChange}
                    value={this.state.icon}
                    required
                />
                <FieldGroup
                    name="image"
                    label="Image:"
                    onChange={this.handleFieldChange}
                    value={this.state.image}
                />
                <FieldGroup
                    name="badge"
                    label="Badge:"
                    onChange={this.handleFieldChange}
                    value={this.state.image}
                />
                <FieldGroup
                    name="url"
                    label="Click URL:"
                    onChange={this.handleFieldChange}
                    value={this.state.url}
                    required
                />
                <FieldGroup
                    name="sound"
                    label="Sound URL:"
                    onChange={this.handleFieldChange}
                    value={this.state.sound}
                />
                <FieldGroup
                    name="vibration"
                    label="Vibration:"
                    placeholder="[300,200,300,200,300]"
                    onChange={this.handleFieldChange}
                    value={this.state.vibration}
                />
                <Row>
                    <Col lg={6}>
                        <FieldGroup
                            name="btn1Title"
                            label="Button 1:"
                            placeholder="Button 1 Tilte"
                            onChange={this.handleFieldChange}
                            value={this.state.btn1Title}
                        />
                        <FieldGroup
                            name="btn1Icon"
                            placeholder="Button 1 Icon"
                            onChange={this.handleFieldChange}
                            value={this.state.btn1Icon}
                        />
                        <FieldGroup
                            name="btn1Url"
                            placeholder="Button 1 URL"
                            onChange={this.handleFieldChange}
                            value={this.state.btn1Url}
                        />
                    </Col>
                    <Col lg={6}>
                        <FieldGroup
                            name="btn2Title"
                            label="Button 2:"
                            placeholder="Button 2 Tilte"
                            onChange={this.handleFieldChange}
                            value={this.state.btn2Title}
                        />
                        <FieldGroup
                            name="btn2Icon"
                            placeholder="Button 2 Icon"
                            onChange={this.handleFieldChange}
                            value={this.state.btn2Icon}
                        />
                        <FieldGroup
                            name="btn2Url"
                            placeholder="Button 2 URL"
                            onChange={this.handleFieldChange}
                            value={this.state.btn2Url}
                        />
                    </Col>
                </Row>
                <Button type="submit" bsStyle="primary">Send</Button>
            </form>
        );
    }
}

export default PlainSendForm;


// WEBPACK FOOTER //
// ./src/scenes/Send/components/PlainSendForm/index.js